<template>
  <span>
    <v-list dense>


            <v-list-item
                @click="$emit('selected')"
                v-for="record in result.items"
                :key="record.id"
                color="blue"
                class="mb-2 text-decoration-none rounded-lg"
                :to="`/accounting/bank-reconciliation/fix/${record.uuid}`"
            >

        <v-list-item-avatar size="50" rounded="lg" color="blue lighten-5">
            <v-icon color="blue">mdi-bank-outline</v-icon>
          </v-list-item-avatar>
        <v-list-item-content>

          <v-list-item-title>
             {{ record.account.account_name }}
          </v-list-item-title>
          <v-list-item-subtitle>From: {{ record.from | humanDate }}, To: {{ record.to | humanDate }}</v-list-item-subtitle>
          <v-list-item-subtitle>Created At: {{ record.created_at | humanDateTime }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action-text>
          <v-icon color="grey lighten-2" small>mdi-chevron-right</v-icon>

        </v-list-item-action-text>

      </v-list-item>

    </v-list>
  </span>
</template>
<script>
export default {
  props: ["result"],
  name: "BankReconciliation"
}
</script>


<style scoped>

</style>